module.exports = __webpack_public_path__ + "img/mf.daa572b0.png";